// removed by extract-text-webpack-plugin
module.exports = {"dots":"styles__dots__L8aQE","item":"styles__item__3foGF","bubble-loader":"styles__bubble-loader__28pjF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DotLoader/styles.scss
// module id = 888
// module chunks = 0